import CustomTagsHierarchy from '../../customTagsHierarchy'
import { useState, useEffect } from 'react'
import { backendGetRequest } from '../../../../../helpers/callBackend'

const CPTY_TAG = 4

const CounterpartiesTags = () => {
  const [flattenedTags, setFlattenedTags] = useState([])
  const [groups, setGroups] = useState([])
  const [groupsPageCountExpected, setGroupsPageCountExpected] = useState(0)
  const [groupsPageCountReceived, setGroupsPageCountReceived] = useState(-1)
  const [flattenedTagsPageCountExpected, setFlattenedTagsPageCountExpected] = useState(0)
  const [flattenedTagsPageCountReceived, setFlattenedTagsPageCountReceived] = useState(-1)
  const [flattenedTagsLoading, setFlattenedTagsLoading] = useState(true)
  const [groupsLoading, setGroupsLoading] = useState(true)

  const addCustomTag = (newTag) => {
    setFlattenedTags((prevTags) => [...prevTags, newTag])
  }

  const deleteCustomTag = (deletedTagId) => {
    setFlattenedTags((prevTags) => prevTags.filter((tag) => tag?.id !== deletedTagId))
  }

  const editCustomTag = (editedTag) => {
    setFlattenedTags((prevTags) => prevTags.map((tag) => (tag?.id === editedTag?.id ? editedTag : tag)))
  }

  const addGroup = (newGroup) => {
    if (newGroup && Object.keys(newGroup).length) {
      setGroups((prevGroups) => [...prevGroups, newGroup])
    }
  }

  const deleteGroup = (deletedGroupId) => {
    setGroups((prevGroups) => prevGroups.filter((group) => group?.id !== deletedGroupId))
  }

  const editGroup = (editedGroup) => {
    setGroups((prevGroups) => prevGroups.map((group) => (group?.id === editedGroup?.id ? editedGroup : group)))
  }

  useEffect(() => {
    backendGetRequest('/api/generic-tag/group/', { params: { page_index: 0, group_type: CPTY_TAG } }).then((res) => {
      setGroupsPageCountExpected(res?.data?.total_pages)
      for (let i = 1; i <= res?.data?.total_pages; i++) {
        backendGetRequest('api/generic-tag/group/', { params: { page_index: i, group_type: CPTY_TAG } })
          .then((res) => {
            const generic_groups = res?.data?.generic_groups
            setGroups((prevState) => [...prevState, ...generic_groups])
            setGroupsPageCountReceived((prevState) => prevState + 1)
          })
          .catch(() => {
            setGroupsPageCountExpected((prevState) => prevState - 1)
          })
      }
    })
  }, [])

  useEffect(() => {
    backendGetRequest('/api/generic-tag/', { params: { page_index: 0, group_type: CPTY_TAG } }).then((res) => {
      setFlattenedTagsPageCountExpected(res?.data?.total_pages)
      for (let i = 1; i <= res?.data?.total_pages; i++) {
        backendGetRequest('api/generic-tag/', { params: { page_index: i, group_type: CPTY_TAG } })
          .then((res) => {
            const generic_tags = res?.data?.generic_tags
            setFlattenedTags((prevState) => [...prevState, ...generic_tags])
            setFlattenedTagsPageCountReceived((prevState) => prevState + 1)
          })
          .catch(() => {
            setFlattenedTagsPageCountReceived((prevState) => prevState - 1)
          })
      }
    })
  }, [])

  useEffect(() => {
    setFlattenedTagsLoading(flattenedTagsPageCountExpected > flattenedTagsPageCountReceived)
  }, [flattenedTagsPageCountExpected, flattenedTagsPageCountReceived])

  useEffect(() => {
    setGroupsLoading(groupsPageCountExpected > groupsPageCountReceived)
  }, [groupsPageCountExpected, groupsPageCountReceived])

  return (
    <CustomTagsHierarchy
      title='Hierarchies'
      group_type={CPTY_TAG}
      flattenedTagsLoading={flattenedTagsLoading}
      flattenedTags={flattenedTags}
      groupsLoading={groupsLoading}
      groups={groups}
      addCustomTag={addCustomTag}
      deleteCustomTag={deleteCustomTag}
      editCustomTag={editCustomTag}
      addGroup={addGroup}
      deleteGroup={deleteGroup}
      editGroup={editGroup}
    />
  )
}

export default CounterpartiesTags
